module.exports = "https://img.xiyuyouxi.com/saas/img/overrule_mark.da61a6cb.png";